export const CREATE_RAW_MATERIAL_RETURN_CHALLAN = 'CREATE_RAW_MATERIAL_RETURN_CHALLAN';
export const GET_RAW_MATERIAL_RETURN_CHALLANS = 'GET_RAW_MATERIAL_RETURN_CHALLANS';
export const RAW_MATERIAL_RETURN_CHALLAN_REQUEST = 'RAW_MATERIAL_RETURN_CHALLAN_REQUEST';
export const UPDATE_RAW_MATERIAL_RETURN_CHALLAN = 'UPDATE_RAW_MATERIAL_RETURN_CHALLAN';
export const DELETE_RAW_MATERIAL_RETURN_CHALLAN = 'DELETE_RAW_MATERIAL_RETURN_CHALLAN';
export const RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE = 'RAW_MATERIAL_RETURN_CHALLAN_REQUEST_FAILURE';